const XLSX = require('xlsx')

export const LoadExcelFiles = async(files, mode = 'aoa') => {

    if (!files || !files.length) return []

    const headerOpt = mode === 'aoa' ? 1 : 0

    const readAsArrayBuffer = (file) =>
        new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsArrayBuffer(file)
    })

    const results = await Promise.all(files.map(async (file) => {

        if (!file) return null

        const buf = await readAsArrayBuffer(file)
        const wb = XLSX.read(new Uint8Array(buf), { type: 'array', cellDates: true })
        const ws = wb.Sheets[wb.SheetNames[0]]
        
        if (!ws) return null

        const data = XLSX.utils.sheet_to_json(ws, { header: headerOpt, defval: '' })

        data.forEach(row => {

            if (Array.isArray(row)) {

                for (let i = 0; i < row.length; i++) {

                    if (typeof row[i] === 'string') { row[i] = row[i].trim() }
                }

            } else {

                Object.keys(row).forEach(key => {

                    if (typeof row[key] === 'string') { row[key] = row[key].trim() }
                })
            }
        })

        return { name: file.name, size: file.size, data }
    }))

    return results.filter(Boolean)
}